import { Box, styled } from '@mui/material';

export const ContentContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  borderRadius: '8px',
  overflowY: 'auto',
  border: '1px solid #737F86',
});

export const RowContainer = styled(Box)({
  display: 'grid',
  width: '100%',
  backgroundColor: '#FFFFFF',
  '&:not(:last-of-type)': {
    borderBottom: '1px solid #737F86',
  },
});

export const Cell = styled(Box)({
  padding: '0.75rem 0.5rem',
  fontSize: '0.75rem',
  fontWeight: 500,
  lineHeight: '1rem',
  color: '#1B1C17',
  display: 'flex',
  alignItems: 'center',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  '&:not(:last-of-type)': {
    borderRight: '1px solid #737F86',
  },
});

export const StickyCell = styled(Cell)({
  position: 'sticky',
  left: 0,
  zIndex: 1,
  background: '#FFF',
});
